import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../../../shared/base-api-template-service.model';
import {Core2Config} from '../../../../shared/core2Config';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../../../shared/api-visa.model';
import { ApiResponseModel } from '../../../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class ProcessKeyGuidService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENWAVE_PREFIX + Core2Config.CRM_PREFIX + 'contact-merger/process';
    this.endpoint_path = Core2Config.TENANT_CUSTOM_URL_PREFIX + Core2Config.SENWAVE_PREFIX + Core2Config.CRM_PREFIX + 'contact-merger/process';
    this.httpClient = http;
  }

  processKeyGuid(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    const url = (this.endpoint_path && visa.api_domain_url) ? visa.api_domain_url + this.endpoint_path : this.apiUrl;
    return this.httpClient.get<ApiResponseModel<any>>(url+ '/' + guid, this.getHttpHeader(visa));
  }

}